export { default } from './Select';



// WEBPACK FOOTER //
// ./src/design-system/atoms/Select/index.jsx